import service from '@/utils/request'

export const clientList = (params) => {
  return service({
    url: 'blade-system/client/list',
    method: 'GET',
    params,
  })
}

export const dictList = (params) => {
  return service({
    url: 'blade-system/dict/list',
    method: 'GET',
    params,
  })
}